import type { FaireProductEntity } from "../../entity_types/product";

export const p_7i07l8ta2v: FaireProductEntity = {
  token: "p_7i07l8ta2v",
  type: "product",
  name: "Stockist Display Sign - About P.F.",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/07616b3e78fd1be057c1a8cffaaa5466b69d375f544f28fc5b8a1b17ab34e599.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b3f8e38ebd4a831c123fc6c42cfccd066c96a756f9b6914fc1c0f34a24b6c51f.png",
  ],
  priceDollars: 1,
  description:
    'Sold individually, limit 1 per order. Not for resale. \n\nAs requested, we are now offering a sign + wood block for your P.F. Candle Co. display to educate your customers about our brand.\n\nSign reads:\n\n"P.F. Candle Co. is a Los Angeles-based home fragrance company owned and operated by wife-and-husband team Kristen Pumphrey & Thomas Neuberger. We believe that fragrance is an extension of your home design, and create high-quality products with accessible price points in mind.\n\nP.F. is a completely independent business: what started as a one-woman operation in 2008 is now an entire team designing and producing our collection under one roof in Southern California. As we grow, so does our commitment to sustainability, to our planet, and to our crew who makes it all happen."',
  tags: [],
  msrpDollars: 2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:56.869Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
